import { createStackNavigator } from '@react-navigation/stack';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import AccountButton from 'src/presentation/components/molecules/AccountButton';
import { useHeaderStyle } from 'src/presentation/hooks/useHeaderStyle';
import { useActiveLanguage } from 'src/presentation/hooks/useActiveLanguage';
import { headerlessStackScreenOptions } from 'src/presentation/navigation/defaultScreenOptions';
import type { InspirationNavigation } from 'src/presentation/navigation/types/NavigationTypes';
import InspirationScreen from 'src/presentation/screens/InspirationScreen';

const Stack = createStackNavigator<InspirationNavigation>();

export default function InspirationStackNavigator() {
	useActiveLanguage();

	const headerStyle = useHeaderStyle();

	return (
		<Stack.Navigator screenOptions={{ ...headerlessStackScreenOptions, title: Translations.tabsRelaxation }}>
			<Stack.Screen
				component={InspirationScreen}
				name={Constants.screenInspiration}
				options={{
					headerShown: true,
					headerStyle,
					headerRight: () => <AccountButton style={{ marginHorizontal: Dimens.padding18 }} />,
				}}
			/>
		</Stack.Navigator>
	);
}
